import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  CreateLeaveCancel,
  CreateLeaveRejoining,
  GetCompoffWorkedDate,
  ImageUpload,
  SpecificLeave
} from "../../Repository/Api";
import { imagepath } from "../../Repository/BaseUrl";
import { NonEmptyValidation } from "../../Store/validate";
import { NumberOfDays } from "../Common/FinancialYear";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";
const StaffSpecificView = () => {
  const { access_token, first_name, desingation, department } = useSelector((state) => state?.auth?.auth);
  const { id } = useParams();
  const token = access_token;
  const navigate = useNavigate();

  const [SpecificProfile, setSecificProfile] = useState({});
  const [applyRejoinModel, setApplyRejoinModel] = useState(false);
  const [createRejoin, setCreateRejoin] = useState([]);
  const [validation, setValidation] = useState({});
  const [compensation_date, setCompensation_date] = useState([]);
  const [apply, setApply] = useState({});
  // console.log(SpecificProfile)
  useEffect(() => {
    getSpecificlist();
    getCompoffWorkedDate();
  }, [id]);

  const setData = (e, key) => {
    let TempData = createRejoin;
    TempData[key] = e;
    setCreateRejoin(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const getCompoffWorkedDate = async () => {
    const response = await GetCompoffWorkedDate(token);
    if (response && response.statusCode === 200) {
      let workdate = response.data.map((label) => ({
        label: moment(label.date).format("DD-MM-yyyy"),
        value: label.id,
      }));
      setCompensation_date(workdate);

    } else {
      errorMsg(response.message);
    }
  };
  const setArrayData = (e, key, index) => {
    let arr = [];
    arr = createRejoin[key] ?? [];
    if (index !== null) {
      arr.splice(index, 1);
    } else {
      arr.push(e);
    }

    setCreateRejoin({
      ...createRejoin,
      [key]: arr,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.joining_date = NonEmptyValidation(createRejoin?.joining_date);
    validate.joining_time = NonEmptyValidation(createRejoin?.joining_time);

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        leave_id: id,
        joining_date: createRejoin.joining_date,
        joining_time: createRejoin.joining_time,
        medical_certificate: createRejoin.medical_certificate,
      };

      const response = await CreateLeaveRejoining(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateRejoin({});
        e.target.reset();
        setApplyRejoinModel(false);
        window.location.reload();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const UploadDocument = async (e, key) => {
    const file = e.target.files[0];

    const maxSizeInBytes = 2 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      errorMsg("File size exceeds the limit of 2MB");
      return;
    }

    let formData = new FormData();
    let str = file.name;
    formData.append("file", file);
    formData.append("fileName", moment().format("YYYYMMDDHHmmss") + "_" + str);
    formData.append("file_path", "/medical_certificate");

    const response = await ImageUpload(formData);
    if (response && response.statusCode === 200) {
      setArrayData(response.data, key, null);
      successMsg(response.message);
    } else {
      errorMsg(response.message);
    }
  };
  const getSpecificlist = async () => {
    const response = await SpecificLeave(id, token);
    if (response && response.statusCode === 200) {
      setSecificProfile(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  const setStatusData = (e, key) => {
    setApply({ ...apply, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const setValidationValue = (key, value) => {
    setValidation({ ...validation, [key]: value });
  };
  const handleUpdate = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.cancellation_type = NonEmptyValidation(apply?.cancellation_type);
    if (apply?.cancellation_type === "partially_cancel") {
      validate.start_date = NonEmptyValidation(apply?.start_date);
      validate.end_date = NonEmptyValidation(apply?.end_date);
    }

    setValidation(validate);
    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        id: id,
        cancellation_type: apply.cancellation_type,
        start_date: apply.start_date,
        end_date: apply.end_date,
      };
      const response = await CreateLeaveCancel(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setApply({});
        e.target.reset();
        window.location.reload();
      } else {
        errorMsg(response.message);
      }
    }
  };
  // console.log('SpecificProfilewww', moment(SpecificProfile?.start_date).utcOffset('+05:30').format('hh:mm'))


  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox mb-5">
                <h6 className="labeltitle">Leave Application</h6>
                <form onSubmit={(e) => handleUpdate(e)}>
                  <div className="row">
                    <div className="col-lg-3">
                      <label className="labeltext"> Nature of Leave </label>
                      <input
                        type="text"
                        className="fieldinput"
                        defaultValue={SpecificProfile?.nature_of_leave}
                        disabled
                      />
                    </div>
                    {SpecificProfile?.duration_type === "half_day" ? (
                      <>
                        <div className="col-lg-3">
                          <label className="labeltext"> Duration Type</label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={SpecificProfile?.duration_type}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext"> Half Day Type</label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={SpecificProfile?.half_day_leave_type}
                            disabled
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.commuted_type ? (
                      <div className="col-lg-3">
                        <label className="labeltext"> Commuted Type</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={
                            SpecificProfile?.commuted_type !== undefined
                              ? SpecificProfile.commuted_type
                                .toString()
                                .replace(/half_pay/g, "Half Pay")
                                .replace(/full_pay/g, "Full Pay")
                              : ""
                          }
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.nature_of_leave ===
                      "Special Casual Leave (SCL)" ||
                      SpecificProfile?.nature_of_leave === "On Duty" ? (
                      <>
                        <div className="col-lg-3">
                          <label className="labeltext">
                            Title of the Program
                          </label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={SpecificProfile?.title_of_the_program}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext">Topic</label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={SpecificProfile?.topic}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext">Organized By</label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={SpecificProfile?.organized_by}
                            disabled
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.nature_of_leave ===
                      "Child Care Leave (CCL)" ? (
                      <>
                        <div className="col-lg-3">
                          <label className="labeltext">Child Name</label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={
                              SpecificProfile?.children_detail?.name
                            }
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext">Child DOB</label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={moment(
                              SpecificProfile?.children_detail?.dob
                            ).format("DD-MM-yyyy")}
                            disabled
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div className="col-lg-3">
                      <label className="labeltext">
                        {SpecificProfile?.nature_of_leave_code === "permissions" ? 'Total Hours' :
                          '  No. of Days'}

                      </label>
                      <input
                        type="text"
                        className="fieldinput"
                        defaultValue={SpecificProfile?.no_of_days?.toFixed(2)}
                        disabled
                      />
                    </div>
                    <div className="col-lg-3">
                      <label className="labeltext">Leave Start Date</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={moment(SpecificProfile?.start_date).format(
                          "DD-MM-yyyy"
                        )}
                        disabled
                      />
                    </div>
                    {SpecificProfile?.nature_of_leave_code === "permissions" ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Start Time</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.start_date).utcOffset('+05:30').format('hh:mm')}
                          disabled
                        />
                      </div>) : ''}
                    {SpecificProfile?.nature_of_leave_code === "permissions" ? (
                      <div className="col-lg-3">
                        <label className="labeltext">End Time</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.end_date).utcOffset('+05:30').format('hh:mm')}
                          disabled
                        />
                      </div>) : ''}
                    {SpecificProfile?.nature_of_leave_code === "permissions" ? '' : (
                      <div className="col-lg-3">
                        <label className="labeltext">Leave End Date</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.end_date).format(
                            "DD-MM-yyyy"
                          )}
                          disabled
                        />
                      </div>)}
                    {SpecificProfile?.prefix ? (
                      <div className="col-lg-3">
                        <label className="labeltext"> Prefix</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.prefix).format(
                            "DD-MM-yyyy"
                          )}
                          disabled
                        />
                        <br />
                        <small>
                          No of prefix Holidays :
                          <span className="fw-bold ms-2">
                            {NumberOfDays(SpecificProfile?.prefix, SpecificProfile?.start_date)}
                          </span>
                        </small>
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.suffix ? (
                      <div className="col-lg-3">
                        <label className="labeltext"> Suffix</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(SpecificProfile?.suffix).format(
                            "DD-MM-yyyy"
                          )}
                          disabled
                        />
                        <br />
                        <small>
                          No of suffix Holidays :
                          <span className="fw-bold ms-2">
                            {SpecificProfile?.no_of_days !== 1 ?
                              NumberOfDays(SpecificProfile?.end_date, SpecificProfile?.suffix) :
                              NumberOfDays(SpecificProfile?.start_date, SpecificProfile?.suffix)
                            }
                          </span>
                        </small>
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.hod_alternate_person_name ? (
                      <div className="col-lg-3">
                        <label className="labeltext">
                          Hod Alternate Person
                        </label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.hod_alternate_person_name}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.compensation_date ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Worked Date</label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={
                            SpecificProfile?.compensation_date_details?.map((item, i) => (
                              moment(item.date).format("DD-MM-yyyy")
                            )).join(', ')}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.nature_of_leave === "Out Of Station" || SpecificProfile?.nature_of_leave_code === "permissions" ? (
                      ""
                    ) : (
                      <>
                        <div className="col-lg-3">
                          <label className="labeltext">Alternate</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={
                              SpecificProfile?.alternate === "no_class"
                                ? SpecificProfile?.alternate?.replace(/_/g, " ")
                                : SpecificProfile?.alternate
                            }
                            disabled
                          />
                        </div>
                        {SpecificProfile?.alternate === "arranged" ? (
                          <div className="col-lg-3">
                            <label className="labeltext">Alternate Person</label>
                            <input
                              type="text"
                              className="fieldinput"
                              value={SpecificProfile?.alternate_person_name}
                              disabled
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="col-lg-3">
                          <label className="labeltext">
                            Additional Responsibility
                          </label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={
                              SpecificProfile?.additional_responsibilities &&
                                SpecificProfile?.additional_responsibilities !==
                                undefined
                                ? SpecificProfile?.additional_responsibilities
                                  .toString()
                                  .replace(/true/g, "Yes")
                                  .replace(/false/g, "No")
                                : ""
                            }
                            disabled
                          />
                        </div>
                        {SpecificProfile?.additional_responsibilities ===
                          true ? (
                          <div className="col-lg-3">
                            <label className="labeltext">
                              Additional Responsible Person
                            </label>
                            <input
                              type="text"
                              className="fieldinput"
                              value={
                                SpecificProfile?.additional_responsibilities_alternate_person_name
                              }
                              disabled
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="col-lg-3">
                          <label className="labeltext">
                            Leaving Headquarters
                          </label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={
                              SpecificProfile?.leaving_head_quaters !==
                                undefined
                                ? SpecificProfile.leaving_head_quaters
                                  .toString()
                                  .replace(/true/g, "Yes")
                                  .replace(/false/g, "No")
                                : ""
                            }
                            disabled
                          />
                        </div>
                        {SpecificProfile?.leaving_head_quaters === true ? (
                          <div className="col-lg-3">
                            <label className="labeltext">Location</label>
                            <input
                              type="text"
                              className="fieldinput"
                              value={
                                SpecificProfile?.location_during_leave_period
                              }
                              disabled
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {SpecificProfile?.reference_attachment ? (
                      <div className="col-lg-3">
                        <label className="labeltext">
                          Ref... (Attach Document)
                        </label>
                        <div className="fieldinputfile">
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(
                                `${imagepath}${SpecificProfile?.reference_attachment}`
                              );
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="col-lg-3">
                      <label className="labeltext">Reason</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.reason}
                        disabled
                      />
                    </div>
                    {SpecificProfile?.nature_of_leave_code === "permissions" ? "" :
                      <div className="col-lg-3">
                        <label className="labeltext">
                          Address - Leave Period
                        </label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.address}
                          disabled
                        />
                      </div>
                    }
                    {SpecificProfile?.hod_comment ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Hod Comment</label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.hod_comment}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.admin_comment ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Admin Comment</label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.admin_comment}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.director_comment ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Director Comment</label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.director_comment}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.joining_report_details?.joining_date ? (
                      <>
                        <div className="col-lg-3">
                          <label className="labeltext">Rejoin Date</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={moment(
                              SpecificProfile?.joining_report_details
                                ?.joining_date
                            ).format("DD-MM-yyyy")}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext">Rejoin Time</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={
                              SpecificProfile?.joining_report_details
                                ?.joining_time
                            }
                            disabled
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {SpecificProfile?.status === "approved" ? (
                          <>
                            {(SpecificProfile?.joining_letter_submitted === false && SpecificProfile?.joining_letter_needed === true) ? (
                              <div className="col-lg-3">
                                <label className="labeltext">
                                  Leave Rejoin
                                </label>
                                <div>
                                  <button
                                    className="approvebutton"
                                    onClick={() => {
                                      setApplyRejoinModel(true);
                                    }}
                                  >
                                    Apply Rejoin
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {SpecificProfile?.joining_report_details
                      ?.medical_certificate ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Medical Certificate</label>
                        <div className="fieldinputfile">
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(
                                `${imagepath}${SpecificProfile?.joining_report_details
                                  ?.medical_certificate[0]}`
                              );
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.cancellation_hod_comment ? (
                      <div className="col-lg-3">
                        <label className="labeltext">
                          Hod Cancellation Comment
                        </label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.cancellation_hod_comment}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.cancellation_admin_comment ? (
                      <div className="col-lg-3">
                        <label className="labeltext">
                          Admin Cancellation Comment
                        </label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.cancellation_admin_comment}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {SpecificProfile?.cancellation_director_comment ? (
                      <div className="col-lg-3">
                        <label className="labeltext">
                          Director Cancellation Comment
                        </label>
                        <textarea
                          type="text"
                          className="fieldinput"
                          value={SpecificProfile?.cancellation_director_comment}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {!SpecificProfile?.joining_letter_submitted &&
                      SpecificProfile?.status === "approved" &&
                      !SpecificProfile?.cancellation_type ? (
                      <>
                        <div className="col-lg-3">
                          <label className="labeltext">Cancel Leave</label>
                          <select
                            className="fieldinput"
                            defaultValue={apply?.cancellation_type}
                            onChange={(e) =>
                              setStatusData(e.target.value, "cancellation_type")
                            }
                            onBlur={(e) => {
                              setValidationValue(
                                "cancellation_type",
                                NonEmptyValidation(e.target.value)
                              );
                            }}
                          >
                            <option value="">Select Option</option>
                            <option value="fully_cancel">Fully Cancel</option>
                            <option value="partially_cancel">
                              Partial Cancel
                            </option>
                          </select>
                          <small className="validationerror">
                            {validation?.cancellation_type?.message
                              ? `Cancel Type ${validation?.cancellation_type?.message}`
                              : ""}
                          </small>
                        </div>
                        {apply?.cancellation_type === "partially_cancel" ? (
                          <>
                            <div className="col-lg-3">
                              <div>
                                <label className="labeltext">
                                  Start Date *
                                </label>
                                <input
                                  type="date"
                                  placeholder="Start Date"
                                  className="fieldinput"
                                  defaultValue={apply?.start_date}
                                  onChange={(e) =>
                                    setStatusData(e.target.value, "start_date")
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "start_date",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                  min={moment(
                                    SpecificProfile?.start_date
                                  ).format("YYYY-MM-DD")}
                                  max={moment(SpecificProfile?.end_date).format(
                                    "YYYY-MM-DD"
                                  )}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.start_date?.message
                                  ? `Start Date ${validation?.start_date?.message}`
                                  : ""}
                              </small>
                            </div>
                            <div className="col-lg-3">
                              <div>
                                <label className="labeltext"> End Date *</label>
                                <input
                                  type="date"
                                  placeholder="End Date"
                                  className="fieldinput"
                                  defaultValue={apply?.end_date}
                                  onChange={(e) =>
                                    setStatusData(e.target.value, "end_date")
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "end_date",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                  min={moment(
                                    SpecificProfile?.start_date
                                  ).format("YYYY-MM-DD")}
                                  max={moment(SpecificProfile?.end_date).format(
                                    "YYYY-MM-DD"
                                  )}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.end_date?.message
                                  ? `End Date ${validation?.end_date?.message}`
                                  : ""}
                              </small>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )
                    }
                  </div>
                  {SpecificProfile?.status === "approved" &&
                    !SpecificProfile?.cancellation_type ? (
                    <div className="row my-5">
                      <div className="col-lg-6 mx-auto my-auto centertext">
                        <div className="row">
                          <div className="col-lg-6">
                            <button
                              className="requestbtn"
                              onClick={() => {
                                navigate(-1);
                              }}
                            >
                              Back
                            </button>
                          </div>
                          {!SpecificProfile?.joining_letter_submitted &&
                            <div className="col-lg-6">
                              <button className="approvebutton">
                                Update Leave
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="centertext mt-3">
                      <button
                        className="requestbtn"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Back
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>

        {/*  Rejoin Leave Date Apply Modal */}
        <CustomModal
          open={applyRejoinModel}
          onClickOutside={() => {
            setApplyRejoinModel(false);
            setCreateRejoin({});
            setValidation({});
          }}
        >
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Rejoin Apply</h5>
              </div>
              <div className="modal-body p-0 ">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center  mt-0">
                    <div className="container ">
                      <div className="row justify-content-center">
                        <div className="col-lg-8">
                          <div className=" my-5 px-3">
                            <div className="row justify-content-center mt-2">
                              <div className="col-lg-10">
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Date of Rejoining:
                                  </label>
                                  <input
                                    type="date"
                                    className="fieldinput"
                                    min={moment(
                                      SpecificProfile?.end_date
                                    ).format("YYYY-MM-DD")}
                                    defaultValue={createRejoin.joining_date}
                                    onChange={(e) => {
                                      setData(e.target.value, "joining_date");
                                    }}
                                  />
                                  <small className="validationerror">
                                    {validation?.joining_date?.message
                                      ? `Joining Date ${validation?.joining_date?.message}`
                                      : ""}
                                  </small>
                                </div>
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Joining Day Type
                                  </label>
                                  <select
                                    className="fieldinput"
                                    defaultValue={createRejoin?.joining_time}
                                    onChange={(e) =>
                                      setData(e.target.value, "joining_time")
                                    }
                                  >
                                    <option value="">Select Option</option>
                                    <option value="forenoon">
                                      Morning (9am-1pm)
                                    </option>
                                    <option value="afternoon">
                                      Afternoon (1pm-6pm)
                                    </option>
                                  </select>
                                  <small className="validationerror">
                                    {validation?.joining_time?.message
                                      ? `Joining Time ${validation?.joining_time?.message}`
                                      : ""}
                                  </small>
                                </div>
                                {SpecificProfile?.medical_certificate_required === true ? (
                                  <div className="mb-3">
                                    <label className="labeltext">
                                      Ref... (Attach Document)
                                    </label>
                                    <input
                                      type="file"
                                      className="fieldinputfile"
                                      id="myfile"
                                      onChange={(e) =>
                                        UploadDocument(e, "medical_certificate")
                                      }
                                      accept="application/pdf"
                                    />
                                    <br />
                                    <small className="d-flex">Max File upload:200kb</small>
                                    {!createRejoin?.medical_certificate ? (
                                      ""
                                    ) : (
                                      <span
                                        className="namelink"
                                        onClick={() => {
                                          window.open(
                                            `${imagepath}${createRejoin?.medical_certificate}`
                                          );
                                        }}
                                        target="_blank"
                                      >
                                        View Document
                                      </span>
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div className="my-3">
                  <button
                    type="button"
                    className="btn mx-2 modelclosebtn"
                    onClick={() => {
                      setApplyRejoinModel(false);
                      setValidation({});
                      setCreateRejoin({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 modelsubmitbtn">Apply</button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default StaffSpecificView;
